import { Component, Input } from '@angular/core';
import { Tutorial } from '@ca/core/models';
import { TutorialService } from '@ca/core/services';

@Component({
    selector: 'ca-tutorial-tile',
    templateUrl: './tutorial-tile.component.html',
    styleUrls: ['./tutorial-tile.component.scss'],
})
export class TutorialTileComponent {
    @Input() tutorial: Tutorial;

    constructor(private tutorialService: TutorialService) {}

    openTutorial(tutorial: Tutorial): void {
        if (tutorial.externalId != null) {
            const tutorialIdCode: string = tutorial.externalId;

            this.tutorialService.activateTopic(tutorialIdCode);
        }
    }
}
